<template>
  <div class="bin" :style="`background-color: ${bin.status.color}`">
    <div class='bin-container'>
      <div class="text-title">{{bin.serialNumber}}</div>
      <div class="text-title">{{bin.status.status}}</div>
      <div>{{bin.username}}</div>
      <div class='bin-info'>
        <img :src='bin.icon' alt="photo" :style="{opacity:bin.status.status.includes('OUT')?'0.6':'1'}">
        <div class="bin-detail">
          <div>{{bin.time1}}</div>
          <div>{{bin.time2}}</div>
          <div class="text-title">{{bin.compartment}}</div>
        </div>
      </div>
      <div class="text-title">{{bin.tag?bin.tag:'null'}}</div>
    </div>
    
    <div class="bin-context">
      <md-menu md-size="medium" md-align-trigger>
        <md-button md-menu-trigger><md-icon>more_horiz</md-icon></md-button>
        <md-menu-content>
            <!-- <md-menu-item @click="$emit('detail')">View detail</md-menu-item> -->
            <md-menu-item @click="$emit('update')" v-if='accessRight3'>Update</md-menu-item>
            <md-menu-item @click="$emit('delete')" v-if='accessRight3'><div style="color:red">Delete</div></md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
  </div>
</template>

<script>
// import StatusCircle from '@/components/StatusCircle'

export default {
  props:{
    bin:{
      type:Object,
      default:()=>{}
    }
  },
  computed: {
    accessRight3(){
      let roleRight=['ROOT','CUSTOMER','MASTER','ADMIN','CONTRACTOR'];
      return roleRight.includes(this.$store.state.role)
    },
    // percentage() {
    //   return 100
    // },
    // progressColor() {
    //   if (this.itemStatus === 0) {
    //     return '#6D6E71' // Unassign
    //   }

    //   else if (this.itemStatus==1) { // Good
    //     return '#00C14D'
    //   } else if (this.itemStatus==2) { // Low
    //     return '#EB9515'
    //   } else if (this.itemStatus==-1) { // Critical / Expired
    //     return '#ED1D24'
    //   }

    //   return '#6D6E71'
    // }
  }
}
</script>

<style lang="scss" scoped>
.bin {
  display: flex;
  // flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  padding: 16px;
  align-self: stretch;
  
  img{
    background-color: white;
    // padding: 4px;
    object-fit: contain;
    width: 72px;
    height: 72px;
    border-radius: 4px;
  }
  .bin-container{
    display: flex;
    flex-direction: column;
    font-size: 16px;
    color: #fff;
    line-height: 24px;
  }

  // .bin-status {
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: center;
  //   margin-right: 16px;
  // }

  .bin-info {
    flex-grow: 1;
  
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    margin-bottom: 8px;

    .bin-detail{
      margin-left:10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }

  .bin-context {
    /deep/ .md-icon {
      color: #fff;
    }

    /deep/ .md-button {
      min-width: 48px;
    }
  }
  .text-title{
    font-weight: bold;
    font-size: 18px;
  }
}
</style>
